var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayArrowFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31887 11.674L27.7355 11.6934L17.5088 27.7254L7.31887 11.674Z",
    fill: "#E6E0E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayArrowFilled);
export default __webpack_public_path__ + "static/media/play_arrow_filled.c9bea0ad121f06632728e4171a2d7739.svg";
export { ForwardRef as ReactComponent };